import { isEmpty } from 'ramda';

import { TQueryData } from '../types';

export const checkHasData = (data: TQueryData | undefined): data is TQueryData => {
  return Boolean(data && !isEmpty(data.pages[0]?.estimationHistory));
};
